module.exports = __webpack_public_path__ + "077eddd796479225b0127a9946fc91c7.jpg";